import React from 'react'
import { Paragraph, Button, H5 } from '@fs/zion-ui'
import { leaveGroup } from '@fs/zion-tree-groups'
import { useTranslation } from 'react-i18next'

export default function GroupCardContentsPending({ group, refetchGroupList }) {
  const [t] = useTranslation()

  const handleCancelRequest = () => {
    leaveGroup(group.id)
      .then(() => refetchGroupList())
      .catch(console.error)
  }

  return (
    <>
      <H5 size="H6" supplementary>
        {group.name}
      </H5>
      <Paragraph size="xs">{t('group-management.pending-join-request.description')}</Paragraph>
      <Button data-testid="pending-join-request-page.cancel-request.button" onClick={handleCancelRequest}>
        {t('group-management.cancel-request.action')}
      </Button>
    </>
  )
}
